<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M30.73,9.65A15.49,15.49,0,0,0,14.3.16C4,1.54-2,13.59,2.5,22.86L.35,24.15a.65.65,0,0,0,0,1.11l5.31,3.52a.86.86,0,0,0,.89,0A1,1,0,0,0,7,28l0-6.62A.63.63,0,0,0,6,20.74l-1.27.76C1.15,13.85,6.17,3.9,14.67,2.8,23.76,1.32,31.34,10.49,29,19.23a13.07,13.07,0,0,1-12.26,10.1A1.34,1.34,0,0,0,16.82,32C27.85,31.92,35.12,19.57,30.73,9.65Z"
        />
    <path
        d="M16.89,5.16A1,1,0,0,0,16,6.31v10.3a1.36,1.36,0,0,0,.28.85l3.23,3.91a.75.75,0,0,0,1.25-.06,1.4,1.4,0,0,0,0-1.63l-2.95-3.57V6.31A1.05,1.05,0,0,0,16.89,5.16Z"
        />
</svg>
